import moment from 'moment-timezone';
import { useApiQuery } from '../../../../../../../infra/api';
import { getTimezone, getViewerIdAndKind, useSession } from '../../../../../../../infra/session';
import { endpoints } from '../../../../../network';
import { getCampaignOwnerOrViewerIdAndKind } from '../../../../utils/get-campaign-owner-or-viewer-id-and-kind';
import { useRouteParams } from '../../../../../../../infra/routing';
import { useCampaignDetails } from '../../../../hooks';
export var usePromoCodes = function () {
    var _a;
    var session = useSession().data;
    var campaignId = useRouteParams().campaignId;
    var campaign = useCampaignDetails(campaignId).campaign;
    var viewerIdAndKind = getViewerIdAndKind(session);
    var timezone = getTimezone(session);
    var ownerOrViewerIdAndKind = getCampaignOwnerOrViewerIdAndKind(campaign, session);
    var isViewerCampaignOwner = campaign ? campaign.ownerId === (viewerIdAndKind === null || viewerIdAndKind === void 0 ? void 0 : viewerIdAndKind.id) : true;
    var _b = useApiQuery({
        endpoint: endpoints.promoCodesQuery,
        payload: {
            ownerType: ownerOrViewerIdAndKind === null || ownerOrViewerIdAndKind === void 0 ? void 0 : ownerOrViewerIdAndKind.kind,
            ownerId: ownerOrViewerIdAndKind === null || ownerOrViewerIdAndKind === void 0 ? void 0 : ownerOrViewerIdAndKind.id,
        },
        options: {
            enabled: !!ownerOrViewerIdAndKind,
            keepPreviousData: true,
        },
    }), promoCodesData = _b.data, isLoading = _b.isLoading;
    var filteredPromoCodes = (_a = promoCodesData === null || promoCodesData === void 0 ? void 0 : promoCodesData.rows) === null || _a === void 0 ? void 0 : _a.filter(function (promoCode) {
        var _a;
        var expirationRule = (_a = promoCode.rules) === null || _a === void 0 ? void 0 : _a.find(function (rule) { return rule.kind === 2; });
        if (!expirationRule)
            return true;
        var now = moment().tz(timezone);
        var expirationDate = moment(expirationRule.endDate).tz(timezone);
        return expirationDate.isAfter(now);
    });
    return {
        promoCodes: filteredPromoCodes || [],
        isPromoCodesLoading: isLoading,
        isViewerCampaignOwner: isViewerCampaignOwner,
    };
};
